import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStaff } from '../../../store/actions/staffActions';
import ModalActionButton from '../../elements/ModalActionButton';
import { updateClassDivision } from '../../../store/actions/classesDivisionsActions';
import TextField from '../../elements/form/TextField';
import NumberField from '../../elements/form/NumberField';

const EditClassArm = ({classId, classArm, closeFunction}) => {
    const [armPayload, setArmPayload] = useState(classArm)
    const [validationErrors, setValidationErrors] = useState({})
    const dispatch = useDispatch()
    const classesSelector = useSelector(state => state.classes)

    useEffect(() => {
      dispatch(fetchStaff(`onboarded=true`, 0, 0))
    
      return () => {
        
      }
    }, [dispatch])


    const validateForm = () => {
        let errors = {}

        if(!armPayload.label || armPayload.label === ''){
            errors.label = true
        }

        if(!armPayload.maxStudentCount || armPayload.maxStudentCount === ''){
            errors.maxStudentsCount = true
        }
    
        setValidationErrors(errors)
    
        return errors
    }

    const pushClassArm = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: 'ERROR',
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            class: classId,
            ...armPayload
        }

        dispatch(updateClassDivision(classArm._id, payload))
    }

    return (
        <div className='w-full'>
            <div className=''>
                <TextField
                    inputLabel="Arm Label" 
                    inputPlaceholder={`Eg: A for BASIC7A`}
                    fieldId="class-arm-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={armPayload?.label || ''}
                    hasError={validationErrors && validationErrors.label} 
                    returnFieldValue={(value)=>{setArmPayload({...armPayload, label: value})}}
                />
            </div>
            <div className='mt-4 relative'>
                <NumberField
                    inputType="number" 
                    fieldId={`max-students`}
                    inputLabel="Maximum students for this arm" 
                    requiredField={true}
                    preloadValue={armPayload?.maxStudentCount || ''}
                    hasError={validationErrors.maxStudentsCount} 
                    returnFieldValue={(value)=>{setArmPayload({...armPayload, maxStudentCount: value})}}
                />
                <p className='text-xs text-gray-500 mt-[5px]'>The number of students in a class arm can not be above the amount you provide here.</p>
            </div>


            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Class Arm`}
                    buttonAction={()=>{pushClassArm()}}
                    processing={classesSelector.updatingClassArm}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default EditClassArm